export default {
    'PREQUESTION.TITLE': 'Vous sélectionnez un créneau à plus de 10 jours. Est-ce à la demande du client ?',
};
